/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';

import { getOptionsFromEnum } from '../enumUtils';
import './index.scss';

/**
 * implementation of Segmented button that can represent a choice of multiple otpions
 * (usually a short set of options, like 2-5).
 */
const SegmentedButton = ({
  type,
  value,
  onChange,
  disabled,

  hasError,
  validate,

  /** Optional provide specific options */
  buttonOptions,

  /** Allows current selection to be unselected (and set to null) by clicking it again */
  canDeselect = true
}) => {

  let options = buttonOptions;
  if (!options) {
    // support enums type
    options = getOptionsFromEnum(type);
  }

  const click = (v) => {
    if (disabled) return;
    onChange(v, {
      onAfterChange: () => {
        validate(); // automatically revalidate on each change
      }
    });
  };

  return (
    <div style={{ display: 'inline-block'}}
      className={`component-segmented-button ${hasError ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
      <div style={{ display: 'table' }}>
        {options?.map?.((option, index) => {
          let isOn = value === option.value;
          return (
            <div className={`option ${isOn ? 'selected' : ''}`}
              key={index}
              style={{display: 'table-cell'}}
              onClick={() => click(isOn && canDeselect ? null : option.value)}>
              {option.text}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SegmentedButton;